import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    address,
    email,
    fax,
    firstTime,
    phone,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxpayerName,
    address2,
    district,
    district2,
    province,
    province2,
    taxId1,
    taxId2,
    taxId3,
    certificate,
    signer,
    fullName,
    timeSign,
    ariseTimes,
    date,
    email2,
    fax2,
    organizationName,
    phone2,
    taxpayerName2,
    checkbox1,
    checkbox2,
    checkbox3,
  },
} = checkout;

const validation = Yup.object().shape({
  [address.name]: Yup.string().required(address.errorMsg),
  [address2.name]: Yup.string().required(address2.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [district2.name]: Yup.string().required(district2.errorMsg),
  [province.name]: Yup.string().required(province.errorMsg),
  [province2.name]: Yup.string().required(province2.errorMsg),
  [certificate.name]: Yup.string().required(certificate.errorMsg),
  [email.name]: Yup.string().required(certificate.errorMsg).email(email.invalidMsg),
  [email2.name]: Yup.string().required(certificate.errorMsg).email(email2.invalidMsg),
  [fax.name]: Yup.string().optional(),
  [fax2.name]: Yup.string().optional(),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [organizationName.name]: Yup.string().required(organizationName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [checkbox1.name]: Yup.string().required(checkbox1.errorMsg),
  [checkbox2.name]: Yup.string().required(checkbox2.errorMsg),
  [checkbox3.name]: Yup.string().required(checkbox3.errorMsg),
  [phone.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone.invalidMsg)
    .required(phone.errorMsg),
  [phone2.name]: Yup.string()
    .matches(/^(?:\+?84|0)(\d{9,10})$/, phone2.invalidMsg)
    .required(phone2.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId1.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId1.errorMsg),
  [taxId3.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId1.invalidMsg)
    .required(taxId3.errorMsg),
  [taxId2.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId2.invalidMsg)
    .required(taxId2.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [taxpayerName2.name]: Yup.string().required(taxpayerName2.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [ariseTimes.name]: Yup.number().required(ariseTimes.errorMsg),
  [date.name]: Yup.number().required(date.errorMsg),
});

export default validation;
